import React, { createContext, useContext, useState, useEffect } from 'react';
import { sendRequest } from '../api';
import Loader from '../components/Loader';

const StrategyContext = createContext({ strategies: [] });

export const useStrategy = () => {
  return useContext(StrategyContext);
};

export const StrategyProvider = ({ children }) => {
  const [strategies, setStrategies] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchStrategies = async (loading = true) => {
    if (loading) {
      setLoading(true);
    }
    try {
      const response = await sendRequest(`/strategies`);
      setStrategies(response.strategies);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchStrategy = async (strategyId) => {
    try {
      const response = await sendRequest(`/strategies/${strategyId}`);
      return response.strategy;
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  const createStrategy = async (data) => {
    try {
      const response = await sendRequest(`/strategies`, {
        method: 'POST',
        body: JSON.stringify({ strategy: data })
      });
      await fetchStrategies(false);
      return response.strategy;
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  const updateStrategy = async (strategyId, data) => {
    try {
      const response = await sendRequest(`/strategies/${strategyId}`, {
        method: 'PUT',
        body: JSON.stringify({ strategy: data })
      });
      await fetchStrategies(false);
      return response.strategy;
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  const deleteStrategy = async (strategyId) => {
    try {
      await sendRequest(`/strategies/${strategyId}`, {
        method: 'DELETE'
      });
      await fetchStrategies(false);
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  useEffect(() => {
    fetchStrategies();
  }, []);

  return loading ? (
    <div className="flex justify-center items-center h-screen">
      <Loader />
    </div>
  ) : (
    <StrategyContext.Provider 
      value={{ 
        strategies, 
        fetchStrategies,
        fetchStrategy,
        createStrategy,
        updateStrategy,
        deleteStrategy
      }}
    >
      {children}
    </StrategyContext.Provider>
  );
}; 